import React from "react";
import {
    Modal
} from "antd";


const widthMap = {
    sm: 300,
    md: 600,
    lg: 900,
    xl: 1200,
};

function GenericModal(props) {

        return (
            <>
                <a onClick={props.showModal}>
                    {props.button}
                </a>

                <Modal
                    footer={null}
                    width={widthMap[props.size]}
                    title={props.modalTitle}
                    visible={props.visible}
                    onCancel={props.handleCancelModal}
                >
                    {props.modalBody}
                </Modal>
            </>
        );
    }

export default GenericModal;
